import { CookieInitialDecision } from './CookieInitialDecision';

export default CookieInitialDecision;
